import React from 'react'
import {Link} from 'react-router-dom'
import './Header.css'

const Header = () => {
  return (
    <div className='hero'>
        <div className='content'>
            <h1>We Are Security</h1>
            <p>BIO-ZEIT is a security company, based in Johannesburg South Africa, that supplies:</p><p>Time & Attendance software, Access control equipment, Barriers, Gate Motors, CCTV, UPS’s and Inverters.</p>
            <div>
                <Link to='/services' className='btn'>Services</Link>
                <Link to='/contact' className='btn'>Contact</Link>
            </div>
        </div>
    </div>
  )
}

export default Header